var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallColoredLogoAcium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.686,
    height: 86.999,
    viewBox: "0 0 87.686 86.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_856",
    "data-name": "Caminho 856",
    d: "M127.071,226.1l17.4-3.633L170.8,170.159l26.517,52.127,17.436,3.814-43.843-87Z",
    transform: "translate(-127.071 -139.101)",
    fill: "#1c1c1d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallColoredLogoAcium);
export default __webpack_public_path__ + "static/media/smallColoredLogoAcium.f71ade32eb36783f60bb27177f7023cd.svg";
export { ForwardRef as ReactComponent };